export default __webpack_public_path__ + "firebase-app-compat.js";